import { Image } from "components";
import { Dispatch, SetStateAction } from "react";
import NegativeImpactExample3 from "public/evidence-examples/negative-impact3.png";
import NegativeImpactExample4 from "public/evidence-examples/negative-impact4.png";

import ButtonV2 from "elements/ButtonV2";
import { PropertySurveyEvidenceModal } from "../PropertySurveyEvidenceModal";
export const EvidenceModal = (props: {
	setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
	const { setOpen } = props;

	return (
		<PropertySurveyEvidenceModal onAttemptExit={() => setOpen(false)}>
			<p>
				<b>Evidence of Negative Impact</b>
			</p>
			<div className="property-survey-evidence-modal-body-text-container">
				<p className="sm">
					<b>
						Documentation showing easements and negative aspects of a property's
						location are helpful data points we can use to argue for a property
						tax reduction.
					</b>{" "}
					If circumstances surrounding your property reduce its potential resale
					value, please provide as much evidence and documentation as possible.
					<br />
					<br />
					Written descriptions are helpful. However, the assessor’s office
					rarely grants a tax reduction without documentation of an easement or
					dated photos.
				</p>
			</div>
			<p>Example Documents & Photos</p>
			<div className="property-survey-evidence-modal-image-container-grid">
				<Image
					// openInNewTab
					placeholder="blur"
					src={NegativeImpactExample4}
					alt="Negative impact example image"
					quality={100}
				/>
				<Image
					// openInNewTab
					placeholder="blur"
					src={NegativeImpactExample3}
					alt="Second negative impact example image"
					quality={100}
				/>
			</div>
			<ButtonV2
				size="mobile-extra-small"
				onClick={() => setOpen(false)}
				className="mx-auto">
				Back to Question
			</ButtonV2>
		</PropertySurveyEvidenceModal>
	);
};
